// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import { AnyCrmObjectTypePropType } from 'customer-data-objects-ui-components/propTypes/CrmObjectTypes';
import CrmLogger from 'customer-data-tracking/loggers/CrmLogger';
import { useCallback, useMemo, useEffect } from 'react';
import I18n from 'I18n';
import PropTypes from 'prop-types';
import { SearchInput } from 'foundations-components/transitional/components/SearchInput';
import styled from 'styled-components';
import { MIN_SEARCH_LENGTH } from 'customer-data-objects/search/ElasticSearchConstants';
import { isCjkCharacterContained, isOfMinSearchLength
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'crm_... Remove this comment to see the full error message
} from 'crm_data/elasticSearch/ElasticSearchValidation';
import debounce from 'transmute/debounce';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'gene... Remove this comment to see the full error message
import { useStoreDependency } from 'general-store';
import get from 'transmute/get';
import { ENTER } from 'foundations-components/transitional/constants';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TimelineFiltersStore, useTimelineSearch, useTimelineSearchValue } from 'crm-events-data';
import { jsx as _jsx } from "react/jsx-runtime";
const MaxWidthDiv = styled.div.withConfig({
  displayName: "TimelineSearchInput__MaxWidthDiv",
  componentId: "hm8ybz-0"
})(["max-width:360px;transition:width 0.2s ease;", ";"], ({
  shouldBeFullWidth
}) => `width: ${shouldBeFullWidth ? `100%` : `185px`}`);
const SearchTextDependency = {
  stores: [TimelineFiltersStore],
  deref: ({
    objectType
  }) => {
    return get('searchText', TimelineFiltersStore.get(objectType));
  }
};
function TimelineSearchInput({
  objectType,
  onSearch
}) {
  const [isSearchInUse, startSearch, endSearch] = useTimelineSearch();
  const [currentSearchValue, setCurrentSearchValue] = useTimelineSearchValue();
  const searchText = useStoreDependency(SearchTextDependency, {
    objectType
  });
  //clear the search text if filters are reset elsewhere
  useEffect(() => {
    if (searchText === '' && !isSearchInUse) {
      setCurrentSearchValue('');
    }
  }, [isSearchInUse, searchText, setCurrentSearchValue]);
  const performSearchDebounced = useMemo(() => debounce(250, value => {
    onSearch(value);
  }), [onSearch]);
  const handleSearchTextChange = useCallback(({
    target: {
      value
    }
  }) => {
    setCurrentSearchValue(value);
    if (isOfMinSearchLength(value) || value === '') {
      performSearchDebounced(value);
    }
  }, [performSearchDebounced, setCurrentSearchValue]);
  const handleExpand = useCallback(() => {
    if (!isSearchInUse) {
      CrmLogger.logRecordInteraction(objectType, {
        action: 'timeline filter search focused'
      });
      startSearch();
    }
  }, [isSearchInUse, objectType, startSearch]);
  const handleCollapse = useCallback(() => {
    if (currentSearchValue.length === 0) {
      endSearch();
    }
  }, [currentSearchValue, endSearch]);
  const handleGetValidationMessage = useCallback(value => {
    if (value && value.length > 0 && value.length < MIN_SEARCH_LENGTH && !isCjkCharacterContained(value)) {
      return I18n.text('timeline.filters.searchInput.validationMessage', {
        count: MIN_SEARCH_LENGTH - value.length
      });
    }
    return null;
  }, []);
  const handleKeyPress = useCallback(evt => {
    if (evt.keyCode === ENTER) {
      performSearchDebounced(currentSearchValue);
    }
  }, [currentSearchValue, performSearchDebounced]);
  const isInUse = isSearchInUse || currentSearchValue.length > 0;
  return (
    /*#__PURE__*/
    /* @bend-expect trellis-tokenized */
    _jsx(MaxWidthDiv, {
      "data-test-id": "search-div",
      shouldBeFullWidth: isInUse,
      children: /*#__PURE__*/_jsx(FormControl, {
        "aria-label": I18n.text('timeline.filters.searchInput.placeholder'),
        children: /*#__PURE__*/_jsx(SearchInput, {
          clearable: true,
          getValidationMessage: handleGetValidationMessage,
          onBlur: handleCollapse,
          onChange: handleSearchTextChange,
          onFocus: handleExpand,
          onKeyUp: handleKeyPress,
          placeholder: I18n.text('timeline.filters.searchInput.placeholder'),
          role: "search",
          use: "on-dark",
          value: currentSearchValue
        })
      })
    })
  );
}
TimelineSearchInput.propTypes = {
  objectType: AnyCrmObjectTypePropType.isRequired,
  onSearch: PropTypes.func.isRequired
};
export default TimelineSearchInput;